import React from 'react';

import ReactDOM from 'react-dom';

import {WrapStaticContentPage} from 'app/general/WrapStaticContentPage';

import {MaxMembersLimitRow} from './MaxMembersLimitRow';

export function BillingDetailPage() {
  const rowContainer = document.getElementById('max-users-limit-row-container');

  return (
    <WrapStaticContentPage>
      {() =>
        rowContainer
          ? ReactDOM.createPortal(<MaxMembersLimitRow />, rowContainer)
          : null
      }
    </WrapStaticContentPage>
  );
}
